import { makeImmutable } from "../../core";
export class PackagingFeeInstance {
    constructor(params) {
        this.packagingFeeType = params.packagingFeeType;
        this.orderLineIndex = params.orderLineIndex;
        this.subject = params.subject;
        this.quantity = params.quantity;
        makeImmutable(this);
    }
    get subjectCheckoutData() {
        switch (this.subject.type) {
            case "ModifierItem":
                return {
                    tag: "ModifierItemPackagingFeeSubject",
                    modifierItem: this.subject.modifierItemTypeId.value,
                };
            case "ProductType":
                return { tag: "ProductPackagingFeeSubject" };
        }
    }
    get checkoutData() {
        return {
            tag: "PackagingFeeItem",
            orderLineIndex: this.orderLineIndex,
            subject: this.subjectCheckoutData,
            typeId: this.packagingFeeType.id.value,
        };
    }
}
